import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AdminUserService } from '../../../core/services/admin-user.service';
import { DialogModule } from 'primeng/dialog';
import { TableModule, TableLazyLoadEvent } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { TagModule } from 'primeng/tag';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
  selector: 'app-user-management',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    FormsModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    SelectModule,
    TagModule,
    ToggleSwitchModule,
    ConfirmDialogModule,
    ToastModule
  ],
  providers: [ConfirmationService, MessageService],
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.css']
})
export class UserManagementComponent implements OnInit {
  users: any[] = [];
  roles: any[] = [];

  totalRecords: number = 0;
  loading: boolean = true;
  rows: number = 10;

  displayEditModal: boolean = false;
  displayCreateModal: boolean = false;

  public selectedUser: any = {
    idUser: null,
    fullName: '',
    email: '',
    role: null,
    isActive: false
  };

  filters = {
    searchTerms: '',
    roleId: null,
    isActive: undefined
  };

  newUser: any = {
    fullname: '',
    username: '',
    email: '',
    password: '',
    telephone: '',
    birthDate: '',
    role: null,
    isActive: true
  };

  constructor(
    private adminService: AdminUserService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.loadRoles();
  }

  saveNewUser() {
    this.loading = true;
    const payload = {
      fullname: this.newUser.fullname,
      username: this.newUser.username,
      email: this.newUser.email,
      password: this.newUser.password,
      telephone: this.newUser.telephone,
      birthDate: this.newUser.birthDate
    };
    this.adminService.createUser(payload).subscribe({
      next: () => {
        this.displayCreateModal = false;
        this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Administrador creado' });
        this.clearFilters();
      },
      error: (err) => {
        this.loading = false;
        this.cd.detectChanges();
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err.error?.message || 'No se pudo crear el administrador'
        });
      }
    });
  }

  openCreateModal() {
    this.newUser = {
      fullname: '',
      username: '',
      email: '',
      password: '',
      telephone: '',
      birthDate: '',
      role: null,
      isActive: true
    };
    this.displayCreateModal = true;
  }

  clearFilters() {
    this.filters = {
      searchTerms: '',
      roleId: null,
      isActive: undefined
    };
    this.loadUsers({ first: 0, rows: this.rows });
  }

  loadRoles() {
    this.adminService.getRoles().subscribe({
      next: (data) => {
        this.roles = data;
        this.cd.detectChanges();
      },
      error: (err) => console.error("Error roles", err)
    });
  }

  loadUsers(event?: TableLazyLoadEvent) {
    this.loading = true;
    const page = event ? (event.first || 0) / (event.rows || 10) : 0;

    this.adminService.getUsersByFilters(page, this.rows, this.filters).subscribe({
      next: (res) => {
        this.users = res.content;
        this.totalRecords = res.totalElements;
        this.loading = false;
        this.cd.detectChanges();
      },
      error: (err) => {
        this.loading = false;
        this.cd.detectChanges();
      }
    });
  }

  editUser(user: any) {
    this.selectedUser = { ...user };
    this.displayEditModal = true;
  }

  saveUser() {
    if (this.selectedUser.idUser) {
      this.loading = true;
      this.adminService.updateUser(this.selectedUser.idUser, this.selectedUser).subscribe({
        next: () => {
          this.displayEditModal = false;
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Usuario actualizado' });
          this.loadUsers();
        },
        error: () => {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No se pudo actualizar' });
        }
      });
    }
  }

  onSearch() {
    if (this.filters.searchTerms?.trim() === '') {
      this.filters.searchTerms = '';
    }
    this.loadUsers({ first: 0, rows: this.rows });
  }

  toggleStatus(user: any) {
    this.confirmationService.confirm({
      message: `¿Confirma cambiar el estado de ${user.fullName}?`,
      header: 'Confirmación',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sí',
      rejectLabel: 'No',
      accept: () => {
        const id = user.idUser || user.id;
        this.adminService.deactivateUser(user.idUser).subscribe({
          next: () => {
            this.messageService.add({ severity: 'success', summary: 'Actualizado', detail: 'Estado cambiado' });
            this.loadUsers();
          },
          error: () => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al cambiar estado' });
          }
        });
      }
    });
  }
}
